module.exports = __webpack_public_path__ + "img/13.8e3ca9f6.jpg";